import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { preventDefault, useCallbacks, usePartial } from 'shared/hooks/utils';
import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import Error from './icons/error.svg';
import { TimedRenderer } from 'console/react-elements/timed-renderer';
import { currentServerUnixTime, prettyTimeInterval } from 'webui/utils/time';
import { OfflineHelpDialog } from 'console/offline-pane/help-dialog/help-dialog';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { TabContext } from 'console/navigation/context/type';
import { useShowWiFiConfiguration } from 'console/smart-config/show';
import { useNavigate } from 'react-router';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const OfflineBanner = memo(function OfflineBanner() {
    const server_time = useAppSelector((state) => state.server_time);
    const { custom_tab_device: device } = useContext(TabContext);
    const navigate = useNavigate();
    const openConnectToWifi = usePartial(navigate, 'smart-config/prepare');
    const [dialog_shown, closeDialog, openDialog] = useBooleanState(false);
    const need_show_wifi_configuration = useShowWiFiConfiguration();
    const setIsConnectToWifiOpenHandler = useCallbacks([
        preventDefault,
        openConnectToWifi,
    ]);
    const setDialogShownHandler = useCallbacks([preventDefault, openDialog]);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { width: "100%", position: "relative", boxSizing: "border-box", display: "flex", p: 1, sx: {
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? '#3d3d3d' : '#808080',
                    color: 'common.white',
                    flexDirection: {
                        xs: 'column',
                        sm: 'row',
                    },
                }, children: [_jsxs(Box, { display: "flex", flexGrow: 1, justifyContent: "center", sx: {
                            alignItems: {
                                sm: 'center',
                            },
                        }, children: [_jsx(CustomIcon, { Icon: Error, color: "error", sx: {
                                    mr: 1,
                                } }), _jsxs(Typography, { variant: "subtitle1", fontWeight: "500", children: ["\u041D\u0435 \u043D\u0430 \u0441\u0432\u044F\u0437\u0438:\u00A0", device?.last_connect_time != null && (_jsx(TimedRenderer, { active: true, interval: 5e3, children: () => (_jsx(_Fragment, { children: prettyTimeInterval(currentServerUnixTime(server_time) -
                                                (device?.last_connect_time ?? 0), {
                                                accusative: true,
                                                nbsp_unicode: true,
                                            }) })) }))] })] }), _jsx(Box, { display: "flex", justifyContent: "center", flexShrink: 0, sx: {
                            width: {
                                xs: '100%',
                                sm: 'auto',
                            },
                        }, children: need_show_wifi_configuration ? (_jsxs(ButtonGroup, { size: "small", color: "neutral", fullWidth: true, sx: {
                                maxWidth: 400,
                            }, children: [_jsx(Button, { onClick: setDialogShownHandler, sx: {
                                        color: 'rgba(255,255,255,0.8)',
                                    }, children: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u044B" }), _jsx(Button, { onClick: setIsConnectToWifiOpenHandler, sx: { color: 'rgba(255,255,255,0.8)' }, children: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Wi-Fi" })] })) : (_jsx(Button, { onClick: setDialogShownHandler, size: "small", color: "neutral", variant: "outlined", sx: {
                                color: 'rgba(255,255,255,0.8)',
                                width: '100%',
                                maxWidth: 300,
                            }, children: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u044B" })) })] }), _jsx(OfflineHelpDialog, { onClose: closeDialog, open: dialog_shown })] }));
});
